var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { ButtonIcon, COLORS_THEME } from 'grilnica-reactstrap';
import { mdiClose, mdiCheck } from '@mdi/js';
import { connectComponent, errorActions } from '../../index';
var ButtonIconConfirm = function (_a) {
    var icon = _a.icon, iconPath = _a.iconPath, title = _a.title, action = _a.action, errorActions = _a.errorActions, className = _a.className, disabled = _a.disabled, iconColor = _a.iconColor, size = _a.size;
    var _b = useState(false), showConfirmControls = _b[0], setShowConfirmControls = _b[1];
    var _c = useState(false), isSendingRequest = _c[0], setSendingRequest = _c[1];
    var onClick = function () {
        setShowConfirmControls(true);
    };
    if (showConfirmControls) {
        return (React.createElement("div", { className: 'd-flex ' + (className ? className : '') },
            React.createElement(ButtonIcon, { iconPath: mdiClose, title: 'Отмена', className: 'mr-2', disabled: isSendingRequest, size: size ? size : 'md', hoverIconColor: 'primary', onClick: function () {
                    setShowConfirmControls(false);
                } }),
            React.createElement(ButtonIcon, { disabled: isSendingRequest, size: size ? size : 'md', hoverIconColor: 'orange', iconPath: mdiCheck, color: COLORS_THEME.warning, title: 'Подтвердить', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setSendingRequest(true);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, 4, 5]);
                                return [4 /*yield*/, action()];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 5];
                            case 3:
                                e_1 = _a.sent();
                                errorActions.setError(e_1);
                                return [3 /*break*/, 5];
                            case 4:
                                setShowConfirmControls(false);
                                setSendingRequest(false);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); } })));
    }
    else {
        return (React.createElement(ButtonIcon, { iconPath: (icon === null || icon === void 0 ? void 0 : icon.iconPath) || iconPath, color: (icon === null || icon === void 0 ? void 0 : icon.iconColor) || iconColor, size: size ? size : 'md', title: title, onClick: onClick, className: className, disabled: disabled }));
    }
};
export default connectComponent(function () { return ({}); }, function (dispatch) { return ({
    errorActions: errorActions(dispatch),
}); }, ButtonIconConfirm);
//# sourceMappingURL=ButtonIconConfirm.js.map